<template>
  <b-modal size="lg" v-model="visible" :hide-header="true" :hide-footer="true" @hidden="hide">
    <div class="certificate-container">
      <certificate-daily-summary-pure
        v-if="certificateData.type === CERTIFICATE_TYPE.DAILY_SUMMARY"
        :displayedRole="certificateData.displayedRole"
        :displayedName="certificateData.displayedName"
        :groupName="certificateData.groupName"
        :countCall="certificateData.countCall"
        :displayedDate="certificateData.displayedDate"
      />
      <certificate-fifty-calls-pure
        v-if="certificateData.type === CERTIFICATE_TYPE.FIFTY_CALLS"
        :displayedRole="certificateData.displayedRole"
        :displayedName="certificateData.displayedName"
        :groupName="certificateData.groupName"
        :countCall="certificateData.countCall"
        :displayedDate="certificateData.displayedDate"
      />
      <toolbar class="toolbar" @close="hide" @go-prev="goPrev" @go-next="goNext" />
    </div>
  </b-modal>
</template>

<style scoped>
.certificate-container {
  position: relative;
}

.toolbar {
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translate(0, 74px);
}
</style>

<script>
// Components
import CertificateDailySummaryPure from '../components/CertificateDailySummaryPure';
import CertificateFiftyCallsPure from '../components/CertificateFiftyCallsPure';
import Toolbar from '../components/Toolbar';

// Utils
import moment from 'moment';
import {getTodayBannerState, setTodayBannerState} from '../utils/storage';
import {CERTIFICATE_TYPE, CertificateCursor} from '../utils/certificate-cursor';

// APIs
import {countSuccessCall, getGroupName} from '../api';

export default {
  components: {
    CertificateDailySummaryPure,
    CertificateFiftyCallsPure,
    Toolbar,
  },

  data() {
    return {
      visible: false,
      certificateCursor: null,
      certificateData: null,
    };
  },

  created() {
    this.CERTIFICATE_TYPE = CERTIFICATE_TYPE;
  },

  computed: {
    userId() {
      return this.$store.state.user._id;
    },

    userEmail() {
      return this.$store.state.user.email;
    },
  },

  methods: {
    getDisplayedRole() {
      const DOCTOR_ROLES = ['owner', 'bac-sy-truong-nhom', 'bac-sy-pho-nhom', 'bac-sy'];
      return DOCTOR_ROLES.includes(this.$store.state.user.role) ? 'Bác sĩ' : 'TNV';
    },

    getDisplayedName() {
      return this.$store.state.user.name;
    },

    show({certificateCursor, certificateData}) {
      this.certificateCursor = certificateCursor;
      this.certificateData = certificateData;
      this.visible = true;
    },

    hide() {
      this.visible = false;
    },

    async getCertificateData(certificateCursor) {
      const startTime = certificateCursor.date;
      const endTime = moment(startTime).add(1, 'day').valueOf();
      const count = await countSuccessCall(this.$service, this.userId, startTime, endTime);

      switch (certificateCursor.type) {
        case CERTIFICATE_TYPE.DAILY_SUMMARY:
          return count >= 1
            ? {
                type: CERTIFICATE_TYPE.DAILY_SUMMARY,
                displayedRole: this.getDisplayedRole(),
                displayedName: this.getDisplayedName(),
                groupName: await getGroupName(this.$service),
                countCall: count,
                displayedDate: moment(certificateCursor.date).format('DD/MM/YYYY'),
              }
            : null;

        case CERTIFICATE_TYPE.FIFTY_CALLS:
          return count >= 50
            ? {
                type: CERTIFICATE_TYPE.FIFTY_CALLS,
                displayedRole: this.getDisplayedRole(),
                displayedName: this.getDisplayedName(),
                groupName: await getGroupName(this.$service),
                countCall: count,
                displayedDate: moment(certificateCursor.date).format('DD/MM/YYYY'),
              }
            : null;
        default:
          throw new RangeError('certificateCursor.type');
      }
    },

    async checkAndShow() {
      const currentTime = moment().valueOf();
      const todayBannerState = getTodayBannerState(currentTime, this.userEmail);

      // 1. If there are >= 50 calls today (and haven't seen popup FIFTY_CALLS), show a popup banner, and update localStorage
      if (!todayBannerState.haveSeenPopupFiftyCalls) {
        const todayStartTime = moment(currentTime).startOf('day').valueOf();
        const certificateCursor = new CertificateCursor(todayStartTime, CERTIFICATE_TYPE.FIFTY_CALLS);
        const certificateData = await this.getCertificateData(certificateCursor);
        if (certificateData) {
          this.show({certificateCursor, certificateData});
          setTodayBannerState({...todayBannerState, haveSeenPopupFiftyCalls: true}, currentTime, this.userEmail);
          return;
        }
      }

      // 2. If there is >= 1 call yesterday (and haven't seen popup DAILY_SUMMARY), show a popup banner, and update localStorage
      if (!todayBannerState.haveSeenPopupDailySummary) {
        const yesterdayStartTime = moment(currentTime).startOf('day').subtract(1, 'day').valueOf();
        const certificateCursor = new CertificateCursor(yesterdayStartTime, CERTIFICATE_TYPE.DAILY_SUMMARY);
        const certificateData = await this.getCertificateData(certificateCursor);
        if (certificateData) {
          this.show({certificateCursor, certificateData});
          setTodayBannerState({...todayBannerState, haveSeenPopupDailySummary: true}, currentTime, this.userEmail);
          return;
        }
      }
    },

    async goPrev() {
      for (let cursor = this.certificateCursor.prev(); cursor != null; cursor = cursor.prev()) {
        const data = await this.getCertificateData(cursor);
        if (data) {
          this.certificateCursor = cursor;
          this.certificateData = data;
          return;
        }
      }
      this.$swal('Không còn dữ liệu nào nữa');
    },

    async goNext() {
      for (let cursor = this.certificateCursor.next(); cursor != null; cursor = cursor.next()) {
        const data = await this.getCertificateData(cursor);
        if (data) {
          this.certificateCursor = cursor;
          this.certificateData = data;
          return;
        }
      }
      this.$swal('Không còn dữ liệu nào nữa');
    },
  },

  mounted() {
    this.checkAndShow();
  },
};
</script>
